/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState} from 'react'
import { Link, useParams } from 'react-router-dom'
import toast, {Toaster} from "react-hot-toast";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import Pagination from '../../../../Components/Common/Pagination';
import SummaryCount from '../../../../Components/Vendors/SummaryCount';
import AppContainer from '../../../../Components/Structure/AppContainer';
import VendorTransactions from '../../../../Components/Vendors/VendorTransactions';
import ajaxBank from '../../../../util/remote/ajaxBank';
import ajaxVendor from '../../../../util/remote/ajaxVendor';
import TableHeader from '../../../../Components/Common/TableHeader';
import Loader from '../../../../Components/Common/Loader';
import RemoteLogOut from '../../../RemoteLogOut';
import useStateCallback from '../../../../util/customHooks/useStateCallback';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightFromBracket, faMoneyBillTransfer, faUserLock } from '@fortawesome/free-solid-svg-icons';
import ajaxStudent from '../../../../util/remote/ajaxStudent';
import VendorCommissions from '../../../../Components/Vendors/VendorCommissions';
import ProcessDisbursement from '../../../../Components/Vendors/ProcessDisbursement';
import AddFloat from '../../../../Components/Vendors/AddFloat';
import AuthContext from '../../../../Context/AuthContext';
import SchoolContext from '../../../../Context/SchoolContext';
import VendorDepositsAndActivations from '../../../../Components/Vendors/VendorDepositsAndActivations';
import Select from "react-select";
import * as XLSX from "xlsx";
import PrintFilter from '../../../../Components/Vendors/PrintFilter';


const VendorProfilePage = props => {
  const {id, user_id} = useParams();
  const [vendorTransactions, setVendorTransactions] = useState([]);
  const [vendorCommissions, setVendorCommissions] = useState([]);
  const [page,setPage] = useState(1)
  const [meta,setMeta] = useState([])
  const [commissionPage,setCommissionPage] = useState(1)
  const [commissionMeta,setCommissionMeta] = useState([])
  const [loading,setLoading] = useState(false)
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);
  const [loading5, setLoading5] = useState(false);
  const [loading6, setLoading6] = useState(false);
  const [loading9, setLoading9] = useState(false);
  const [loading8, setLoading8] = useState(false);

  const [vendorAmounts, setVendorAmounts] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [commissionAmounts, setCommissionAmounts] = useState(false);
  const [commissionStartDate, setCommissionStartDate] = useState("");
  const [commissionEndDate, setCommissionEndDate] = useState("");
  const [vendorProfile, setVendorProfile] = useState(false);
  const [vendorWalletBalance, setVendorWalletBalance] = useState(false);
  const [vendorCommissionBalance, setVendorCommissionBalance] = useState(false);

  const [modal, setModal] = useStateCallback(false);
  const {schoolList} = useContext(SchoolContext); 
  const [school, setSchool] = useState("");

  const [pmStartDate, setPmStartDate] = useState("");
  const [pmEndDate, setPmEndDate] = useState("");
  const [type, setType] = useState("");
  const [loading7, setLoading7] = useState(false);
  const [transactionHighlights, setTransactionHighlights] = useState([]);
  const [vendorActivationsAndDeposits, setVendorActivationsAndDeposits] = useState([]);
  const [adpage,setAdPage] = useState(1)
  const [admeta,setAdMeta] = useState([])
  const [adStartDate, setAdStartDate] = useState("");
  const [adEndDate, setAdEndDate] = useState("");
  const { userId } = useContext(AuthContext);
  const [printableList, setPrintableList] = useState([]);
  
  
  useEffect(() => {
      if (id) {
        getVendorProfile();
      }
    }, [id]);

  useEffect(() => {
      if (user_id) {
        getVendorWalletBalance();
        getVendorCommissionBalance();
        getTransactionHighlights();
  
      }
  }, [user_id]);

  useEffect(() => {
      if (pmStartDate || pmEndDate || type) {
        searchVendorTransactions();
      } else {
        fetchVendorTransactions(page);
      }
    }, [page, user_id]);

useEffect(() => {
  fetchVendorCommissions(commissionPage);
}, [commissionPage, user_id]);

useEffect(() => {
    if (startDate || endDate) {
        searchTransactionAmounts();
    } else {
        getTransactionAmounts();
    }
}, [user_id]);

useEffect(() => {
  if (commissionStartDate || commissionEndDate) {
      searchCommissionAmounts();
  } else {
      getCommissionAmounts();
  }
}, [user_id]);

useEffect(() => {
      if (pmStartDate || pmEndDate || type) {
        searchVendorTransactions();
      } else {
        fetchVendorTransactions(page);
      }
    }, [page, user_id]);

  useEffect(() => {
      if (school || adStartDate || adEndDate) {
        searchVendorActivationsAndDeposits();
      } else {
        fetchVendorActivationsAndDeposits(adpage);
      }
    }, [adpage, user_id]);

  const getVendorProfile =async()=>{
      if (!id) return;
      const server_response = await ajaxVendor.fetchVendorInfo(id);
      if(server_response.status==="OK"){
        setVendorProfile(server_response.details);
      }else{
        setVendorProfile("404");
      }
  }

  const getVendorWalletBalance = async () => {
    if (!user_id) return;
    setVendorWalletBalance(false)
    const server_response = await ajaxBank.fetchPocketMoneyBalance(user_id);
    
    if (server_response.status === "OK") {
      setVendorWalletBalance(server_response.details);
    } else {
      setVendorWalletBalance('0');
    }
  };

  const getVendorCommissionBalance = async () => {
    if (!user_id) return;
    setVendorCommissionBalance(false)
    const server_response = await ajaxVendor.fetchCommissionBalance(user_id);
    if (server_response.status === "OK") {
      setVendorCommissionBalance(server_response.details);
    } else {
      setVendorCommissionBalance('0');
    }
  };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= meta) {
      setPage(newPage);
    }
  };

  const handleCommissionPagination = (newPage) => {
    if (newPage > 0 && newPage <= commissionMeta) {
      setCommissionPage(newPage);
    }
  };

  const handleAdPagination = (newPage) => {
    if (newPage > 0 && newPage <= admeta) {
      setAdPage(newPage);
    }
  };

  const remoteLogout = (e, item) => {
    setModal(false, () =>
      setModal(
        <RemoteLogOut
          userID={user_id}
          isOpen={true}
        />
      )
    );
  };

  const processDisburse = (e, item) => {
    setModal(false, () =>
      setModal(
        <ProcessDisbursement
          accountID={user_id}
          g={getVendorWalletBalance}
          h={getVendorCommissionBalance}

          isOpen={true}
        />
      )
    );
  };

  const depositFloat = (e, item) => {
    setModal(false, () =>
      setModal(
        <AddFloat
          accountID={user_id}
          g={getVendorWalletBalance}
          isOpen={true}
        />
      )
    );
  };

  

  const fetchVendorTransactions = async (currentPage) => {
      setLoading(true);
      const response = await ajaxBank.fetchUserPocketMoneyTransactions(currentPage, user_id);
      setLoading(false);
      if (response.status === "OK") {
        setMeta(response.details.meta.totalPages);
        setVendorTransactions(response.details.data || []);
      } else {
        setVendorTransactions([]);
      }
  };

  const searchVendorTransactions = async (e) => {
        if (e) {
          e.preventDefault();
        }
        setLoading7(true);
        const server_response = await ajaxBank.searchUserPocketMoneyTransactions(page,user_id,pmStartDate,pmEndDate, type);
        setLoading7(false);
        if (server_response.status === "OK") {
          setMeta(server_response.details.meta.totalPages);
          setVendorTransactions(server_response.details.data || []);
        } else {
          setVendorTransactions([]);
        } 
    };

  const fetchVendorCommissions = async (currentPage) => {
    setLoading4(true);
    const response = await ajaxVendor.fetchVendorCommissions(currentPage, user_id);
    setLoading4(false);
    if (response.status === "OK") {
      setCommissionMeta(response.details.meta.totalPages);
      setVendorCommissions(response.details.data || []);
    } else {
      setVendorCommissions([]);
    }
};

  const getTransactionAmounts = async () => {
        setLoading2(true);
          const server_response = await ajaxVendor.getAllvendorAmounts(user_id);
          setLoading2(false);
          if (server_response.status === "OK") {
            setVendorAmounts(server_response.details);
          } else {
            setVendorAmounts([]);
          }
  };
  
      const searchTransactionAmounts = async () => {
        setLoading3(true);
          const server_response = await ajaxVendor.searchAllvendorAmounts(user_id, startDate, endDate);
          setLoading3(false);
          if (server_response.status === "OK") {
            setVendorAmounts(server_response.details);
          } else {
            setVendorAmounts([]);
          }
    };

    const getCommissionAmounts = async () => {
      setLoading5(true);
        const server_response = await ajaxVendor.getAllvendorCommissions(user_id);
        setLoading5(false);
        if (server_response.status === "OK") {
          setCommissionAmounts(server_response.details);
        } else {
          setCommissionAmounts([]);
        }
  };

    const searchCommissionAmounts = async () => {
      setLoading6(true);
        const server_response = await ajaxVendor.searchAllCommissionAmounts(user_id, commissionStartDate, commissionEndDate);
        setLoading6(false);
        if (server_response.status === "OK") {
          setCommissionAmounts(server_response.details);
        } else {
          setCommissionAmounts([]);
        }
  };

  const getTransactionHighlights = async () => {
    const server_response = await ajaxVendor.fetchVendorHighlights(user_id);
    if (server_response.status === "OK") {
      //store results
      setTransactionHighlights(server_response.details);
    } else {
      //communicate error
      setTransactionHighlights([]);
    }
  };

  const accountTypes = {
    2: "Student Deposits",
    3: "Canteen Purchases",
    4: "Student Withdrawals",
    5: "Buzztime Purchases",
    16: "Termly Fees",
  };

  const totalsMap = {};
  const countMap  = {};
if (vendorAmounts && Array.isArray(vendorAmounts)) {
  vendorAmounts.forEach(item => {
    const id = parseInt(item.account_id, 10);
    // Handle both formatted and raw amount; fallback to 0
    totalsMap[id] = item.total_amount?.total_c || "0";
    countMap[id] = item.transaction_count?.total_p || "0";
  });
}

const commissionTypes = {
  9: "Activation Commissions",
  13: "Replacement Commissions",
  17: "Deposit Commissions",
  20: "Termly Fee Commissions"
};

const commissionTotalsMap = {};
if (commissionAmounts && Array.isArray(commissionAmounts)) {
commissionAmounts.forEach(item => {
  const id = parseInt(item.account_id, 10);
  // Handle both formatted and raw amount; fallback to 0
  commissionTotalsMap[id] = item.total_amount?.total_c || "0";
});
}

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    searchTransactionAmounts(e);
  };

  const handleCommissionSearchSubmit = (e) => {
    e.preventDefault();
    searchCommissionAmounts(e);
  };

  const handlePMTransactionsSearchSubmit = (e) => {
    e.preventDefault();
    searchVendorTransactions(e);
  };

  const getDefaultPin = async (e,item) => {
    e.preventDefault()
    const server_response = await ajaxStudent.setDefaultPin(user_id);
    if (server_response.status === "OK") {
      toast.success(server_response.message, {duration: 10000});
    }
  };

  const handleReset = (e) => {
    e.preventDefault();
    setStartDate("");
    setEndDate("");
    getTransactionAmounts();
    
  };

  const handleCommissionReset = (e) => {
    e.preventDefault();
    setCommissionStartDate("");
    setCommissionEndDate("");
    getCommissionAmounts();
    
  };

  const resetFilters = (e) => {
    e.preventDefault();
    setPmStartDate("");
    setPmEndDate("");
    setPage(1);
    setType("");
    fetchVendorTransactions(1);
  };

  const resetFilters2= (e) => {
    e.preventDefault();
    setSchool("")
    setAdStartDate("");
    setAdEndDate("");
    setAdPage(1);
    fetchVendorActivationsAndDeposits(1);
    
  };

  const fetchVendorActivationsAndDeposits= async (currentPage) => {
      setLoading8(true);
      const response = await ajaxVendor.fetchVendorActivationsAndDeposits(currentPage, user_id);
      console.log(response)
      setLoading8(false);
      if (response.status === "OK") {
        setAdMeta(response.details.meta.totalPages);
        setVendorActivationsAndDeposits(response.details.data || []);
      } else {
        setVendorActivationsAndDeposits([]);
      }
  };

  const searchVendorActivationsAndDeposits = async (e) => {
        if (e) {
          e.preventDefault();
        }
        setLoading9(true);
        const server_response = await ajaxVendor.searchVendorActivationsAndDeposits(adpage,user_id,school,adStartDate, adEndDate);
        setLoading9(false);
        if (server_response.status === "OK") {
          setAdMeta(server_response.details.meta.totalPages);
          setVendorActivationsAndDeposits(server_response.details.data || []);
        } else {
          setVendorActivationsAndDeposits([]);
        } 
    };

    const handleModal5 = () => {
    setModal(false, () =>
      setModal(
        <PrintFilter
          user={user_id}
          g={setPrintableList}
          h={exportToExcel}
          printableList={printableList}
          isOpen={true}
        />
      )
    );
  };

  const exportToExcel = (data) => {
        const worksheetData = (data || []).map((item) => ({
          "Student Name": item.student_name,
          "School": item.school,
          "Student Class": item.group,
          "Amount": item.activity ==="Account Activation" ? "UGX. 40,000" : "UGX. " + item.amount.total_c, 
          "Transaction Details": item.activity ==="Account Activation" ? "Account Activation" : "Deposit",
          "Transaction Date": item.date?.long_date
         }));
      
        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Vendor Activations and Deposits");
      
        XLSX.writeFile(workbook, "vendor_activations_and_deposits.xlsx");
  };

  return (
    <AppContainer title={"Vendor Profile"} >
      {modal}
      <Toaster
          position="top-center"
          reverseOrder={false}
      />
        
      <section class="section profile">
        <div class="row">
          <div class="col-xl-4">
          <div class="row">
          <div class="col-lg-12">
              <div class="cards">
                <div class="card-body profile-card pt-4 d-flex flex-column gradient-my-blue">
                  <div class="main-img-user mb-2">
                    <img
                      alt="avatar"
                      style={{ height: "90px" }}
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/img/figure/user55.png"
                      }
                    />
                  </div>
                  <h3 style={{ color: "white" }}>
                    {vendorProfile.full_name}
                  </h3>
                  <h5 style={{ color: "white" }}>{vendorProfile.username}</h5>
                  
                </div>
              </div>
              <ul class="list-group list-group-flush bg mb-2" style={{display: "flex", flexDirection: "column", paddingLeft: "0", borderTop: "#dee2e6 solid 5px"}}>
                    
                    <li class="p-0 list-group-item">
                        <div class="grid-menu grid-menu-2col">
                            <div class="no-gutters row" style={{marginRight: "0", marginLeft: "0", display:"grid"}}>
                                {["1973", "4749", "9"].includes(userId) ?(<div class="col-sm-12" style={{borderRight: "#dee2e6 solid 5px", borderBottom: "#dee2e6 solid 5px"}}>
                                    <button onClick={depositFloat} class="btn-icon-vertical btn-square btn-transition btn btn-outline-link" style={{padding: "1rem" , minWidth: "100%", backgroundColor:"white", fontSize: "14px", display: "flex",flexDirection:"row-reverse", justifyContent:"space-between", alignItems:"center"}}>
                                        <FontAwesomeIcon icon={faMoneyBillTransfer} style={{ color: "green", marginRight: "3px" }} />Load Virtual Float
                                    </button>
                                </div>):null}
                                <div class="col-sm-12" style={{borderRight: "#dee2e6 solid 5px", borderBottom: "#dee2e6 solid 5px"}}>
                                    <button onClick={getDefaultPin} class="btn-icon-vertical btn-square btn-transition btn btn-outline-link" style={{padding: "1rem" , minWidth: "100%", backgroundColor:"white", fontSize: "14px", display: "flex",flexDirection:"row-reverse", justifyContent:"space-between", alignItems:"center"}}>
                                        <FontAwesomeIcon icon={faUserLock} style={{ color: "teal", marginRight: "3px" }} />Set Default PIN
                                    </button>
                                </div>
                                
                                <div class="col-sm-12" style={{borderRight: "#dee2e6 solid 5px", borderBottom: "#dee2e6 solid 5px"}}>
                                    <button onClick={remoteLogout}  class="btn-icon-vertical btn-square btn-transition btn btn-outline-link" style={{padding: "1rem" , minWidth: "100%", backgroundColor:"white", fontSize: "14px", display: "flex",flexDirection:"row-reverse", justifyContent:"space-between", alignItems:"center"}}>
                                        <FontAwesomeIcon icon={faArrowRightFromBracket} style={{ color: "red", marginRight: "3px" }} /> Remote Log-Out
                                    </button>
                                </div>
                               
                                
                               
                                
                            </div>
                        </div>
                    </li>
                </ul> </div>
              <div class="col-lg-12">
                <div className="card custom-card" style={{paddingBottom:"10px"}}>
                        <div className="card-body map-card">
                        <TableHeader
                            title="Vendor Wallet Statistics"
                            subtitle="Total amount handled by vendor for each transaction type"
                            viewButton={
                              <Link onClick={handleReset} className="" style={{float:"right"}}><i class="fas fa-redo-alt ml-3"></i></Link>
                                 
                          } 
                        />
                        <form className="mg-t-20" onSubmit={handleSearchSubmit}>
      <div className="row gutters-5">
        <div className="col-11-xxxl  col-lg-11 col-12 form-group">
          <div className="row">
            
            
            <div className="col-lg-12 mt-1">
              <div className="flex-fill position-relative">
              <div className="input-group input-daterange" id="datepicker">
                  <input
                    type="date"
                    style={{ border: "1px solid grey" }}
                    className="form-control"
                    placeholder="start date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                  <span
                    className="input-group-text"
                    style={{
                      marginLeft: "-1px",
                      borderTopLeftRadius: "0",
                      borderTopRightRadius: "0",
                      borderBottomLeftRadius: "0",
                      borderBottomRightRadius: "0",
                    }}
                  >
                    to
                  </span>
                  <input
                    type="date"
                    style={{ border: "1px solid grey" }}
                    className="form-control"
                    placeholder="end date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-1-xxxl col-lg-1 col-12 form-group">
        <div className="row">
        <div className="col-lg-12 mt-1">
         <Link onClick={handleSearchSubmit} className="btn btn-primary"><i className="fa fa-search" style={{fontSize:"15px", padding:"8px", color:"white"}}></i></Link></div>
          </div>
        </div>
      </div>
    </form>
    {loading2 || loading3 ? (
  <Loader />
) : (
  <table className="table mb-0 mw-100 color-span">
    <thead>
                <tr>
                <th className="w-50">Transaction Type</th>
                <th className="py-2 px-0" scope="col">Amount</th>
                </tr>
                </thead>
    <tbody>
    {Object.entries(accountTypes).map(([id, label]) => (
    <tr key={id}>
      <td className="w-50">{label}<br/><small>({countMap[id]|| "0"} transactions)</small></td>
      <td className="py-2 px-0">UGX. {totalsMap[id] || "0"}</td>
    </tr>
  ))}
    </tbody>
  </table>
)}

                        </div>
                </div>
              </div>
              <div class="col-lg-12">
                <div className="card custom-card" style={{paddingBottom:"10px"}}>
                        <div className="card-body map-card">
                        <TableHeader
                            title="Vendor Commission Statistics"
                            subtitle="Total commissions received by vendor for each commission type"
                            viewButton={
                              <Link onClick={handleCommissionReset} className="" style={{float:"right"}}><i class="fas fa-redo-alt ml-3"></i></Link>
                                 
                          } 
                        />
                        <form className="mg-t-20" onSubmit={handleCommissionSearchSubmit}>
      <div className="row gutters-5">
        <div className="col-11-xxxl col-lg-11 col-12 form-group">
          <div className="row">
            
            
            <div className="col-lg-12 mt-1">
              <div className="flex-fill position-relative">
              <div className="input-group input-daterange" id="datepicker">
                  <input
                    type="date"
                    style={{ border: "1px solid grey" }}
                    className="form-control"
                    placeholder="start date"
                    value={commissionStartDate}
                    onChange={(e) => setCommissionStartDate(e.target.value)}
                  />
                  <span
                    className="input-group-text"
                    style={{
                      marginLeft: "-1px",
                      borderTopLeftRadius: "0",
                      borderTopRightRadius: "0",
                      borderBottomLeftRadius: "0",
                      borderBottomRightRadius: "0",
                    }}
                  >
                    to
                  </span>
                  <input
                    type="date"
                    style={{ border: "1px solid grey" }}
                    className="form-control"
                    placeholder="end date"
                    value={commissionEndDate}
                    onChange={(e) => setCommissionEndDate(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-1-xxxl col-lg-1 col-12 form-group">
        <div className="row">
        <div className="col-lg-12 mt-1">
         <Link onClick={handleCommissionSearchSubmit} className="btn btn-primary"><i className="fa fa-search" style={{fontSize:"15px", padding:"8px", color:"white"}}></i></Link></div>
          </div>
        </div>
      </div>
    </form>
    {loading5 || loading6 ? (
  <Loader />
) : (
  <table className="table mb-0 mw-100 color-span">
    <thead>
                <tr>
                <th className="w-50">Commission Type</th>

                <th className="py-2 px-0" scope="col">Amount</th>
                </tr>
                </thead>
    <tbody>
    {Object.entries(commissionTypes).map(([id, label]) => (
    <tr key={id}>
      <td className="w-50">{label}</td>
      <td className="py-2 px-0">UGX. {commissionTotalsMap[id] || "0"}</td>
    </tr>
  ))}
    </tbody>
  </table>
)}

                        </div>
                </div>
              </div>
          </div></div>

          <div className="col-xl-8">
            <div className="row">
              <SummaryCount walletBalance={vendorWalletBalance} commissionBalance={vendorCommissionBalance}/>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <div class="card">
                  <div class="card-body pt-3">
                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                      <Row>
                        <Col sm={12}>
                          <Nav variant="pills" className="flex-row mb-1">
                            <Nav.Item>
                              <Nav.Link size="sm" eventKey="first">
                                Transaction History{" "}
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link size="sm" eventKey="second">
                                Commissions History{" "}
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link size="sm" eventKey="third">
                                Deposits & Activations{" "}
                              </Nav.Link>
                            </Nav.Item>
                             <Nav.Item>
                              <Nav.Link size="sm" eventKey="fourth">
                                Vendor Highlights{" "}
                              </Nav.Link>
                            </Nav.Item>
                          </Nav>
                        </Col>

                        <Col sm={12}>
                          <Tab.Content>

                            <Tab.Pane eventKey="first">
                              <form className="mg-t-20" onSubmit={handlePMTransactionsSearchSubmit}>
      <div className="row">
        <div className="col-8-xxxl col-lg-8 col-12 form-group">
          <div className="row">
            
            <div className="col-lg-4">
            <select
                    style={{border: "1px solid grey"}}
                    className="col-12 form-control"
                    value={type}
                    onChange={(e) => setType(e.target.value)}>
                    <option value="" selected disabled>Select type..</option>
                    <option value="2">Student Deposits</option>
                    <option value="3">Canteen Purchases</option>
                    <option value="4">Student Withdrawals</option>
                    <option value="6">Vendor Float Withdrawals</option>
                    <option value="8">Card Activations</option>
                    <option value="14">Wristband Activations</option>
                    <option value="16">Termly Fees</option>



                </select>
            </div>
            <div className="col-lg-8">
              <div className="flex-fill position-relative">
                <div className="input-group input-daterange" id="datepicker">
                  <input
                    type="date"
                    style={{ border: "1px solid grey" }}
                    className="form-control"
                    value={pmStartDate}
                    onChange={(e) => setPmStartDate(e.target.value)}
                    placeholder="start date"
                  />
                  <span
                    className="input-group-text"
                    style={{
                      marginLeft: "-1px",
                      borderTopLeftRadius: "0",
                      borderTopRightRadius: "0",
                      borderBottomLeftRadius: "0",
                      borderBottomRightRadius: "0",
                    }}
                  >
                    to
                  </span>
                  <input
                    type="date"
                    style={{ border: "1px solid grey" }}
                    value={pmEndDate}
                    onChange={(e) => setPmEndDate(e.target.value)}
                    className="form-control"
                    placeholder="end date"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-4-xxxl  col-lg-4 col-12 form-group">
          <button
            type="submit"
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue"
          >
            SEARCH
          </button>
          <button
            type="button"
            onClick={resetFilters}
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-martini ml-2"
          >
            RESET
          </button>
        </div>
      </div>
    </form>
                              <VendorTransactions walletTransactions={vendorTransactions} loading3={loading} loading4={loading7}/>
                              <Pagination currentPage={page} totalPages={meta} onPageChange={handlePagination}/>
                              
                            </Tab.Pane>

                            <Tab.Pane eventKey="second">
                              <TableHeader
                                viewButton={
                                  <Link onClick={processDisburse} className="btn btn-info mb-1" style={{ float: "right" }}>
                                    Process Disbursement
                                  </Link>
                                }
                              />
                              <VendorCommissions commissions={vendorCommissions} loading4={loading4}/>
                              <Pagination currentPage={commissionPage} totalPages={commissionMeta} onPageChange={handleCommissionPagination}/>
                              
                            </Tab.Pane>
                            <Tab.Pane eventKey="third">
                              <div class="heading-layout1 mg-b-25">
                            <TableHeader
                            />
                            <div class="dropdown">
                                <Link onClick={handleModal5} className="btn btn-info mb-1" style={{ float: "right" }}>
                                    Export
                                  </Link>
                            </div>
                        </div>

                              <form className="mg-t-20" onSubmit={searchVendorActivationsAndDeposits}>
      <div className="row">
        <div className="col-8-xxxl col-lg-8 col-12 form-group">
          <div className="row">
            
            <div className="col-lg-5">
            <Select
                onChange={(e) => setSchool(e ? e.school_id : "")}
                getOptionLabel={(option) => option.school_name}
                getOptionValue={(option) => option.school_id}
                isSearchable
                placeholder="Select school..."
                options={Array.isArray(schoolList) ? schoolList : []}
                value={
                  school === ""
                    ? null
                    : Array.isArray(schoolList) &&
                      schoolList.find((value) => value.school_id === school)
                }
              />
            </div>
            <div className="col-lg-7">
              <div className="flex-fill position-relative">
                <div className="input-group input-daterange" id="datepicker">
                  <input
                    type="date"
                    style={{ border: "1px solid grey" }}
                    className="form-control"
                    value={adStartDate}
                    onChange={(e) => setAdStartDate(e.target.value)}
                    placeholder="start date"
                  />
                  <span
                    className="input-group-text"
                    style={{
                      marginLeft: "-1px",
                      borderTopLeftRadius: "0",
                      borderTopRightRadius: "0",
                      borderBottomLeftRadius: "0",
                      borderBottomRightRadius: "0",
                    }}
                  >
                    to
                  </span>
                  <input
                    type="date"
                    style={{ border: "1px solid grey" }}
                    value={adEndDate}
                    onChange={(e) => setAdEndDate(e.target.value)}
                    className="form-control"
                    placeholder="end date"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-4-xxxl  col-lg-4 col-12 form-group">
          <button
            type="submit"
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue"
          >
            SEARCH
          </button>
          <button
            type="button"
            onClick={resetFilters2}
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-martini ml-2"
          >
            RESET
          </button>
        </div>
      </div>
    </form>
                              <VendorDepositsAndActivations activations={vendorActivationsAndDeposits} loading8={loading8} loading9={loading9}/>
                              <Pagination currentPage={adpage} totalPages={admeta} onPageChange={handleAdPagination}/>
                              
                            </Tab.Pane>
                            <Tab.Pane eventKey="fourth">
                              <div className="row">
                                    <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                                      <div className="text-center" style={{marginTop: "10px"}}>
                                        <h3 className="mb-1 number-font" style={{color:"#042954"}}><i className="fe fe-dollar-sign mr-1"></i> <span className="counter">Deposit Insights</span></h3>
                                      </div>
                                      <div className="row">
                                        
                                        
                                        <div className="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">UGX. {transactionHighlights?.largest_deposit?.total_c}</span></h5>
                                            <p className="mb-2 text-dark"> Largest Single Deposit</p>
                                          </div>
                                        </div>
                                        <div className="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0 ">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">UGX. {transactionHighlights?.average_deposit?.total_c}</span></h5>
                                            <p className="mb-2 text-dark"> Average Deposit</p>
                                          </div>
                                        </div>
                                       
                                         <div className="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">{transactionHighlights?.top_depositor?.user}</span></h5>
                                            <p className="mb-0 text-dark"> Top Depositor</p>
                                            <p className="mb-2 text-dark"> UGX. {transactionHighlights?.top_depositor?.amount} deposited</p>
                                          </div>
                                        </div>
                                         <div className="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0 ">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">{transactionHighlights?.frequent_depositor?.user}</span></h5>
                                            <p className="mb-0 text-dark"> Frequent Depositor</p>
                                            <p className="mb-2 text-dark"> {transactionHighlights?.frequent_depositor?.number} deposits made</p>

                                          </div>
                                        </div>
                                         <div className="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">{transactionHighlights?.vendor_deposit_day?.date?.short_date}</span></h5>
                                            <p className="mb-0 text-dark"> Record Deposit Day</p>
                                            <p className="mb-2 text-dark"> {transactionHighlights?.vendor_deposit_day?.count?.total_c} deposits</p>

                                          </div>
                                        </div>
                                        
                                      </div>
        
        
                                    </div>
                                    <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0">
                                      <div className="text-center" style={{marginTop: "10px"}}>
                                        <h3 className="mb-1 number-font" style={{color:"#042954"}}><i className="fe fe-credit-card mr-1"></i><span className="counter">Purchase Insights</span></h3>
                                      </div>
                                      <div className="row">
                                       
                                        
                                         <div className="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">UGX. {transactionHighlights?.largest_purchase?.total_c}</span></h5>
                                            <p className="mb-2 text-dark"> Largest Single Purchase</p>
                                          </div>
                                        </div>
                                        <div className="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0 ">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">UGX. {transactionHighlights?.average_purchase?.total_c}</span></h5>
                                            <p className="mb-2 text-dark"> Average Purchase</p>
                                          </div>
                                        </div>
                                        <div className="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">{transactionHighlights?.top_purchaser?.user}</span></h5>
                                            <p className="mb-0 text-dark"> Top Buyer</p>
                                            <p className="mb-2 text-dark"> UGX. {transactionHighlights?.top_purchaser?.amount} in purchases</p>
                                          </div>
                                        </div>
                                         <div className="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0 ">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">{transactionHighlights?.frequent_purchaser?.user}</span></h5>
                                            <p className="mb-0 text-dark"> Frequent Buyer</p>
                                            <p className="mb-2 text-dark"> {transactionHighlights?.frequent_purchaser?.number} purchases made</p>

                                          </div>
                                          
                                        </div>
                                        <div className="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0 ">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">{transactionHighlights?.vendor_purchase_day?.date?.short_date}</span></h5>
                                            <p className="mb-0 text-dark"> Record Purchase Day</p>
                                            <p className="mb-2 text-dark"> {transactionHighlights?.vendor_purchase_day?.count?.total_c} purchases</p>

                                          </div>
                                          
                                        </div>
                                        <div className="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">{transactionHighlights?.consistent_purchaser?.user}</span></h5>
                                            <p className="mb-0 text-dark"> Consistent Buyer</p>
                                            <p className="mb-2 text-dark"> {transactionHighlights?.consistent_purchaser?.streak_days?.total_c} Day Streak <small>({transactionHighlights?.consistent_purchaser?.start_date?.short_date} - {transactionHighlights?.consistent_purchaser?.end_date?.short_date})</small></p>
                                          </div>
                                        </div>
                                        <div className="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">{transactionHighlights?.busiest_purchase_hour?.number_of_purchases?.total_c} purchases</span></h5>
                                            <p className="mb-0 text-dark"> Max Purchases in an Hour</p>
                                            <p className="mb-2 text-dark"> {transactionHighlights?.busiest_purchase_hour?.hour_window?.time}</p>
                                          </div>
                                        </div>
                                         
                                         
                                      </div>
                                      
        
        
                                    </div>
                            
                            
                            
                            
                                  </div> 
                              
                              
                            </Tab.Pane>
                          </Tab.Content>
                        </Col>
                      </Row>
                    </Tab.Container>
                  </div>
                </div>
              </div>
              </div>
          </div>
        </div>
      </section>

    </AppContainer>
  )
}

export default VendorProfilePage;